var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClassroom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392.598 392.598",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M359.855,142.481H32.743c-6.012,0-10.925,4.848-10.925,10.925v206.416 c0,6.012,4.848,10.925,10.925,10.925h327.111c6.012,0,10.925-4.849,10.925-10.925V153.406 C370.78,147.329,365.867,142.481,359.855,142.481z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.604,
    y: 164.267,
    style: {
      fill: "#56ACE0"
    },
    width: 305.325,
    height: 184.63
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M150.271,270.158c-18.166,0.711-31.612,13.123-31.612,30.901c0,18.101,14.739,31.289,31.612,30.901 c18.166-0.711,31.612-13.123,31.612-30.901C181.947,282.958,167.143,269.705,150.271,270.158z M168.113,300.994 c-0.711,11.442-7.822,18.941-17.842,19.265c-8.792,0.259-18.101-8.339-17.842-19.265h0.065 c0.711-11.442,7.822-18.941,17.842-19.265c8.792-0.259,18.101,8.339,17.842,19.265H168.113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M221.382,270.158c-18.166,0.711-31.612,13.123-31.612,30.901c0,18.101,14.739,31.289,31.612,30.901 c18.166-0.711,31.612-13.123,31.612-30.901C253.123,282.958,238.319,269.705,221.382,270.158z M239.289,300.994 c-0.711,11.442-7.822,18.941-17.842,19.265c-8.792,0.259-18.101-8.339-17.842-19.265h0.065 c0.711-11.442,7.822-18.941,17.842-19.265c8.792-0.259,18.101,8.339,17.842,19.265H239.289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M108.832,291.297c-0.517-15.321-8.404-20.04-26.053-19.846H59.96v59.798h13.446v-19.071h9.244 l13.382,19.071h16.549L97.39,309.915C105.018,307.135,108.832,300.865,108.832,291.297z M83.232,300.671h-9.826v-17.713h10.149 c6.788,0.129,11.636,0.905,11.636,8.404C95.063,298.731,91.507,300.606,83.232,300.671z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#194F82"
    },
    points: "298.117,304.356 282.602,271.451 264.436,271.451 264.436,331.313 277.883,331.313  277.883,293.624 294.109,326.335 302.061,326.335 318.416,293.624 318.416,331.313 331.863,331.313 331.863,271.451  313.762,271.451  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M196.299,43.636c6.012,0,10.925-4.848,10.925-10.925c0-6.012-4.848-10.925-10.925-10.925 s-10.925,4.848-10.925,10.925S190.287,43.636,196.299,43.636z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M359.855,120.695H324.17l-95.289-90.182C227.717,13.511,213.56,0,196.299,0 c-17.778,0-32.323,14.287-32.711,32l-95.095,88.695h-35.75c-18.036,0-32.711,14.675-32.711,32.711v206.416 c0,18.101,14.675,32.776,32.711,32.776h327.111c18.036,0,32.711-14.675,32.711-32.711V153.406 C392.566,135.37,377.891,120.695,359.855,120.695z M370.78,359.822c0,6.012-4.848,10.925-10.925,10.925H32.743 c-6.012,0-10.925-4.849-10.925-10.925V153.406c0-6.012,4.848-10.925,10.925-10.925h327.111c6.012,0,10.925,4.848,10.925,10.925 V359.822L370.78,359.822z M196.299,21.786c6.012,0,10.925,4.848,10.925,10.925s-4.848,10.925-10.925,10.925 s-10.925-4.848-10.925-10.925S190.287,21.786,196.299,21.786z M171.733,54.238c6.012,6.853,14.739,11.184,24.566,11.184 c10.15,0,19.265-4.655,25.212-11.895l70.853,67.168H100.493L171.733,54.238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M89.244,193.422c6.335,0,11.636,2.65,15.903,7.952l8.404-9.503 c-6.723-7.564-14.998-11.378-24.889-11.378c-16.097-0.065-31.741,12.347-31.741,31.418c0,17.261,13.382,31.095,32,31.095 c9.244,0,17.39-3.879,24.242-11.572l-8.663-8.857c-4.202,5.236-9.632,7.887-16.226,7.887c-11.119-0.453-17.778-9.115-17.455-18.618 C70.562,201.891,78.707,193.034,89.244,193.422z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#194F82"
    },
    points: "163.071,230.335 137.341,230.335 137.341,181.915 123.83,181.915 123.83,242.295  163.071,242.295  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M215.952,242.295h14.352l-26.117-60.444h-13.059l-26.117,60.444h14.352l5.624-13.059h25.341 L215.952,242.295z M190.093,217.471l7.564-17.519l7.499,17.519H190.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M317.511,205.899c-7.046-1.939-13.123-3.038-13.382-7.887c0.129-3.879,3.426-6.465,7.24-5.883 c5.56,0,10.99,2.004,16.226,5.947l6.788-9.891c-6.012-5.172-14.739-8.21-22.626-7.952c-11.572,0-21.721,5.818-21.527,18.036 c-0.065,13.899,9.18,15.58,20.299,19.135c6.077,1.616,11.83,3.491,11.119,7.564c-0.646,4.655-3.685,6.012-7.952,5.947 c-5.56,0-11.507-2.844-18.101-8.598l-8.016,9.891c7.628,7.111,16.226,10.667,25.794,10.667 c12.347,0.711,22.562-7.628,22.109-18.295C336,214.756,329.535,208.679,317.511,205.899z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M280.533,224.711c0.388-9.956-6.077-15.968-18.101-18.747c-7.046-1.939-13.123-3.038-13.382-7.887 c0.129-3.879,3.426-6.465,7.24-5.883c5.56,0,10.99,2.004,16.226,5.947l6.788-9.891c-6.012-5.172-14.739-8.21-22.626-7.952 c-11.572,0-21.721,5.818-21.527,18.036c-0.065,13.899,9.18,15.58,20.299,19.135c6.077,1.616,11.83,3.491,11.119,7.564 c-0.646,4.655-3.685,6.012-7.952,5.947c-5.56,0-11.507-2.844-18.101-8.598l-8.016,9.891c7.628,7.111,16.226,10.667,25.794,10.667 C270.707,243.717,280.921,235.378,280.533,224.711z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassroom);
export default __webpack_public_path__ + "static/media/classroom.f48941d7f065c7d8158fecf221ebdf5f.svg";
export { ForwardRef as ReactComponent };